<template>
    <div class="sides-class">
        <div v-for="space in Space" :key="space.id">
            <a :href="space.redirect" target="_blank" v-if="space.id != '000'">
                <img class="space-img" :src="space.img" alt />
            </a>
            <img class="space-img" :src="space.img" alt v-else @click="send(space)" />
        </div>
        <BecomeMember ref="member"></BecomeMember>
    </div>
</template>

<script>
import BecomeMember from './BecomeMember';
    export default {
        props: {
            Space: {
                type: Array,
                default: () => {
                    return [];
                }
            }
        },
        components: { BecomeMember },
        methods: {
            send(space) {
                let userInfo = this.$store.state.login.userInfo;
                if (userInfo.role_no > 1) {
                    window.open(space.redirect);
                } else {
                    this.$refs.member.show();
                }
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .sides-class {
        max-height: 425px;
        overflow: hidden;
        margin-top: 5px;
    }

    .space-img {
        width: 100%;
        height: 128px;
        border-radius: 8px;
        margin-top: 12px;
    }
</style>
